function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
// @ts-ignore
import React, { useEffect, useRef } from 'react';
import { getPixelRatio, getStyleStr, rotateWatermark } from "./utils";
var BaseSize = 2;
var zIndex = 9;
var color = 'rgba(0,0,0,.15)';
var fontSize = 16;
var fontFamily = 'sans-serif';
var Watermark = function Watermark(props) {
  var content = props.content,
    children = props.children,
    style = props.style,
    className = props.className,
    _props$rotate = props.rotate,
    rotate = _props$rotate === void 0 ? -22 : _props$rotate,
    _props$gap = props.gap,
    gap = _props$gap === void 0 ? [100, 100] : _props$gap;
  var _gap = _slicedToArray(gap, 2),
    gapX = _gap[0],
    gapY = _gap[1];

  // 水印样式
  var getMarkStyle = function getMarkStyle() {
    var markStyle = {
      zIndex: zIndex,
      position: 'absolute',
      left: 0,
      top: 0,
      width: '100%',
      height: '100%',
      pointerEvents: 'none',
      backgroundRepeat: 'repeat',
      // 重复水印
      backgroundPosition: '0px 0px' // 页面左上角开始填充内容
    };

    return markStyle;
  };
  var containerRef = useRef(null);
  var watermarkRef = useRef();

  // 将水印内容添加至页面
  var appendWatermark = function appendWatermark(base64Url, markWidth) {
    if (containerRef.current && watermarkRef.current) {
      var _containerRef$current;
      // 将水印当成一张透明图片添加至整个页面
      watermarkRef.current.setAttribute('style', getStyleStr(_objectSpread(_objectSpread({}, getMarkStyle()), {}, {
        backgroundImage: "url('".concat(base64Url, "')"),
        backgroundSize: "".concat((gapX + markWidth) * BaseSize, "px")
      })));
      (_containerRef$current = containerRef.current) === null || _containerRef$current === void 0 || _containerRef$current.append(watermarkRef.current);
    }
  };

  // 计算水印大小
  var getMarkSize = function getMarkSize(ctx) {
    var defaultWidth = 120;
    var defaultHeight = Number(fontSize);

    // ctx.measureText: 检查字体的宽度，用来重新计算水印的宽高
    if (ctx.measureText) {
      // 定义字体
      ctx.font = "".concat(Number(fontSize), "px");
      // 所有内容的宽度
      var widths = ctx.measureText(content).width;
      defaultWidth = widths;
    }
    return [defaultWidth, defaultHeight];
  };

  // 填充水印文案
  var fillTexts = function fillTexts(ctx, drawX, drawY, drawWidth) {
    var ratio = getPixelRatio();
    var mergedFontSize = Number(fontSize) * ratio;
    ctx.font = "".concat(mergedFontSize, "px ").concat(fontFamily);
    ctx.fillStyle = color;
    ctx.textAlign = 'center';
    ctx.textBaseline = 'top';

    // 偏移到水印宽度的一半的位置（样式优化）
    ctx.translate(drawWidth / 2, 0);
    ctx.fillText(content, drawX, drawY);
  };
  var drawText = function drawText(canvas, ctx, drawX, drawY, rotateX, rotateY, drawWidth, alternateRotateX, alternateRotateY, alternateDrawX, alternateDrawY, markWidth) {
    // 画第一个
    rotateWatermark(ctx, rotateX, rotateY, rotate);
    fillTexts(ctx, drawX, drawY, drawWidth);
    // 保存之前绘制的状态
    ctx.restore();

    // 画第二个
    rotateWatermark(ctx, alternateRotateX, alternateRotateY, rotate);
    fillTexts(ctx, alternateDrawX, alternateDrawY, drawWidth);
    appendWatermark(canvas.toDataURL(), markWidth);
  };

  // 渲染水印
  var renderWatermark = function renderWatermark() {
    // 创建画布
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    if (ctx) {
      // 避免重复创建
      if (!watermarkRef.current) {
        // 创建水印DOM
        watermarkRef.current = document.createElement('div');
      }

      // 获取浏览器像素
      var ratio = getPixelRatio();
      // 水印的宽高
      var _getMarkSize = getMarkSize(ctx),
        _getMarkSize2 = _slicedToArray(_getMarkSize, 2),
        markWidth = _getMarkSize2[0],
        markHeight = _getMarkSize2[1];
      var canvasWidth = (gapX + markWidth) * ratio;
      var canvasHeight = (gapY + markHeight) * ratio;
      canvas.setAttribute('width', "".concat(canvasWidth * BaseSize, "px"));
      canvas.setAttribute('height', "".concat(canvasHeight * BaseSize, "px"));

      // 填充文本的起点横坐标。
      var drawX = gapX * ratio / 2;
      // 填充文本的起点纵坐标。
      var drawY = gapY * ratio / 2;

      // 填充文本的宽度
      var drawWidth = markWidth * ratio;
      // 填充文本的高度
      var drawHeight = markHeight * ratio;

      // 角度 X、Y坐标
      var rotateX = (drawWidth + gapX * ratio) / 2;
      var rotateY = (drawHeight + gapY * ratio) / 2;

      // 多画一个水印，页面上看起来不那么空
      // 填充文本的起点横坐标。
      var alternateDrawX = drawX + canvasWidth;
      // 填充文本的起点纵坐标。
      var alternateDrawY = drawY + canvasHeight;
      // 角度 X、Y坐标
      var alternateRotateX = rotateX + canvasWidth;
      var alternateRotateY = rotateY + canvasHeight;
      ctx.save();
      // 填充文字
      drawText(canvas, ctx, drawX, drawY, rotateX, rotateY, drawWidth, alternateRotateX, alternateRotateY, alternateDrawX, alternateDrawY, markWidth);
    }
  };
  useEffect(renderWatermark, [content, rotate, gap]);
  return /*#__PURE__*/React.createElement("div", {
    ref: containerRef,
    className: className,
    style: _objectSpread({
      position: 'relative'
    }, style)
  }, children);
};
export default Watermark;